module.exports = __webpack_public_path__ + "static/media/030-policewoman.82de05aa.svg";